import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { ScoutingCenter } from 'components/ScoutingCenter';

const ScoutingCenterPage = () => {
  const {
    flags: { useNewNav = false },
  } = useFeatureFlags();

  return (
    <>
      {!useNewNav && <ProfilePageHeader />}
      <ScoutingCenter />
    </>
  );
};
export default ScoutingCenterPage;
